import EventBase from './EventBase'
import EventID from './EventID'

class EventBookMark extends EventBase {
  public constructor() {
    super()
    this.Parameter = ['0', '', '']
  }

  // 剧情ID
  public Code = EventID.BookMark

  /**
   * 书签内容 key
   */

  get Content() {
    return this.Parameter?.[1] ?? ''
  }
  set Content(value) {
    this.Parameter && (this.Parameter[1] = value)
  }
  
  // setLocalesParam(indexes: number[]): void {
  //   super.setLocalesParam([1])
  // }

  // /**
  //  * 设置多语言书签内容
  //  * @param lang  语言
  //  * @param value 内容
  //  */
  // setLocalesContent(lang:string, value:string){
  //   this.setLocalesValue(this.mapId, this.Content, lang, value,"Content")
  // }
  
  // /**
  //  * 获取多语言书签内容
  //  * @param lang 语言
  //  * @returns 
  //  */
  // getLocalesContent(lang:string):string{
  //   return this.getLocalesValue(this.mapId, this.Content, lang)
  // }

  /// <summary>
  /// 书签id
  /// </summary>
  get MarkID() {
    return this.Parameter?.[0] ?? -1
  }
  set MarkID(value) {
    this.Parameter && (this.Parameter[0] = '' + value)
  }
  /// <summary>
  /// 描述信息
  /// </summary>
  get Description() {
    return this.Parameter?.[2] ?? ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[2] = value)
  }

  /// <summary>
  /// 获取显示信息
  /// </summary>
  /// <returns></returns>

  // protected registerAllPropLocales(): void {
  //     super.registerAllPropLocales()
  //     this.registerPropLocales("Content",1)
  // }
}
export default EventBookMark
